export const SET_REASON_FILTERS = 'SET_REASON_FILTERS';

export const RESET_REASON_FILTERS = 'RESET_REASON_FILTERS';

export const SET_REASON_GRID_SORT_CRITERIA = 'SET_REASON_GRID_SORT_CRITERIA';
